<template>
  <div class="flex flex-col items-center justify-center px-6 py-10 text-center">
    <span
      class="flex items-center justify-center w-14 h-14 mb-4 rounded-2xl bg-rose-50 dark:bg-rose-950/40 text-rose-500 ring-1 ring-rose-200/60 dark:ring-rose-900/50"
    >
      <i class="mdi mdi-wifi-off text-[26px]"></i>
    </span>
    <p class="text-sm font-medium text-slate-700 dark:text-slate-200">
      {{ t("notifications_error") }}
    </p>
    <button
      type="button"
      class="mt-3 inline-flex items-center gap-1.5 px-3 py-2 text-xs font-medium rounded-xl text-primary hover:bg-primary/8 transition-colors"
      @click="$emit('retry')"
    >
      <i class="mdi mdi-refresh text-[15px]"></i>
      {{ t("notifications_retry") }}
    </button>
  </div>
</template>

<script setup>
defineProps({
  t: { type: Function, required: true },
});

defineEmits(["retry"]);
</script>
